import {Matter} from "common/types/matter";
import {MatterFetchAction} from "../actions/fetch_matter";
import {MatterAddDocumentsAction} from "../actions/add_documents";
import {MatterRenameAction} from "../actions/rename";
import {MatterUpdateContextAction} from "../actions/update_context";
import {MattersClearAction} from "../actions/clear_matter";
import {MaybeUninitialised} from "modules/redux_types";
import UNINITIALISED from "utils/uninitialised";
import actionTypes from "../constants/action_types";
import {DcDocumentRefreshAction} from "../actions/dc_document_refresh";

export default function matterReducer(
  state: MaybeUninitialised<Matter> = UNINITIALISED,
  action:
    | MatterFetchAction
    | MatterRenameAction
    | MatterUpdateContextAction
    | MattersClearAction
    | MatterAddDocumentsAction
    | DcDocumentRefreshAction,
) {
  if (action.type === actionTypes.MATTER_FETCH.SUCCESS) {
    return (action as MatterFetchAction).payload;
  }

  if (action.type === actionTypes.MATTER_ADD_DOCUMENTS.SUCCESS) {
    return (action as MatterAddDocumentsAction).payload;
  }

  if (action.type === actionTypes.MATTER_CLEAR.SUCCESS) {
    return UNINITIALISED;
  }

  if (action.type === actionTypes.MATTER_RENAME.SUCCESS) {
    if (state === UNINITIALISED) {
      return state;
    }
    const {name} = (action as MatterRenameAction).payload;
    return {
      ...state,
      config: {
        ...state.config,
        name,
      },
    };
  }
  if (action.type === actionTypes.MATTER_UPDATE_CONTEXT.SUCCESS) {
    if (state === UNINITIALISED) {
      return state;
    }
    const {
      id,
      context,
      client_context_id,
      is_project_context_disabled,
    } = (action as MatterUpdateContextAction).payload;
    if (state.id !== id) {
      return state;
    }
    return {
      ...state,
      context,
      ...(client_context_id !== undefined ? {client_context_id} : {}),
      ...(is_project_context_disabled !== undefined
        ? {is_project_context_disabled}
        : {}),
    };
  }
  if (action.type === actionTypes.DC_DOCUMENT_REFRESH.SUCCESS) {
    if (state === UNINITIALISED) {
      return state;
    }
    return {
      ...state,
      documents: state.documents.map(document => {
        if (document.id === action.payload.id) {
          return action.payload;
        }
        return document;
      }),
    };
  }

  return state;
}
